import { StageContext } from '../../Context';
import { PreprocessStage, StageParameters } from '../../Stage';

interface SortParams extends StageParameters {}

class SortStage extends PreprocessStage<SortParams> {
    constructor() {
        super({});
    }

    protected override transformContext(input: StageContext): StageContext {
        const sensors = input.sensors;
        const sortedSensors = sensors.sort((a, b) => a.getScalarValue() - b.getScalarValue());
        return { ...input, sensors: sortedSensors };
    }
}

export default SortStage;
